import type { ComponentProps } from 'react';

type Props = ComponentProps<'svg'>;

const PauseIcon = (props: Props) => {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M 6 6 L 10 6 L 10 18 L 6 18 Z M 18 6 L 18 18 L 14 18 L 14 6 Z"
                fill="currentColor"
            />
        </svg>
    );
};

PauseIcon.displayName = 'PauseIcon';

export default PauseIcon;
